<template>
    <div class="">
        <div class="border border-[#FFF] p-[20px] background">
            <!-- div สำหรับพื้นหลัง -->
            <div class="mt-[25px]">
                <h2 class="PC_H2-SB text-primary-dark">สภาพอากาศวันนี้</h2>
                <div
                    class="rounded-[20px] flex flex-col lg:flex-row items-stretch flex-wrap bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 my-5">
                    <div class="lg:w-[40%] flex flex-col lg:flex-row items-center lg:items-start p-3.5">
                        <div class="w-full lg:w-1/3">
                            <img src="/images/sunIcon.svg" class="mx-auto" />
                        </div>
                        <div class="w-full flex justify-around gap-4 lg:w-2/3">
                            <div class="lg:w-1/2 flex flex-col justify-stretch items-center gap-2.5">
                                <div class="flex items-center mr-9 border-b-2 border-b-primary">

                                    <span class="PC_Body1-SB text-nowrap cursor-pointer px-5 py-1.5"
                                        :class="selectedTab == 'today' ? 'bg-primary !text-white  rounded-t-sm' : ''"
                                        @click="selectedTab = 'today'">
                                        วันนี้
                                    </span>
                                    <span class="PC_Body1-SB text-nowrap cursor-pointer px-5 py-1.5"
                                        :class="selectedTab == 'sunnyDay' ? 'bg-primary !text-white rounded-t-sm' : ''"
                                        @click="selectedTab = 'sunnyDay'">
                                        แดดจัด</span>
                                </div>
                                <div>
                                    <div class=""><span class="mr-2.5">ศุกร์ 7 กุมภาพันธ์ </span><span>15:00</span>
                                    </div>
                                    <h3 class="text-yellow !text-[60px]">37 °C</h3>
                                </div>
                            </div>
                            <div class="lg:w-1/2 flex flex-col justify-stretch">
                                <div class="PC_Body2-SB border-b-2 border-primary py-1.5 mb-2.5">
                                    รายละเอียด</div>
                                <div class="flex flex-col gap-2.5">
                                    <div class="flex items-center gap-1.5 text-primary-dark">
                                        <RainIcon class="w-1/5" />
                                        <span class="text-nowrap">ฝน : 2%</span>
                                    </div>
                                    <div class="flex items-center gap-1.5 text-primary-dark">
                                        <WaterDropIcon class="w-1/5" />
                                        <span class="text-nowrap">ความชื้น : 43%</span>
                                    </div>
                                    <div class="flex items-center gap-1.5 text-primary-dark">
                                        <WindIcon class="w-1/5" />
                                        <span class="text-nowrap">ลม : 5 กม./ชม.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="lg:w-[60%] w-full flex items-center flex-nowrap overflow-auto gap-2.5">
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-secondary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-primary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-primary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-primary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-primary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[90px] lg:w-1/6 border-r border-primary-light px-1.5 py-2.5 flex flex-col justify-center items-center h-full">
                            <span class="PC_Body2-R">16:00</span>
                            <img class="w-[50px] my-1.5" src="/images/sunIcon.svg" />
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h1 class="!text-primary-dark !text-[20px] !font-semibold">สภาพอากาศวันอื่นๆ</h1>
                    <div class="w-full flex items-center gap-4 overflow-auto py-2">
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5 mb-2.5">ศุกร์</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5 mb-2.5">เสาร์</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5  mb-2.5">อาทิตย์</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5  mb-2.5">อังคาร</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5  mb-2.5">พุธ</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5  mb-2.5">พฤหัสบดี</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                        <div
                            class="w-[100px] lg:w-1/7 bg-[rgba(255,255,255,0.80)] px-2.5 py-3.5 flex flex-col justify-stretch items-center h-full rounded-[10px]">
                            <div class="PC_Body2-SB border-b border-primary px-5 py-1.5  mb-2.5">
                                รายละเอียด</div>
                            <span class="PC_Body2-R">7 กุมภาพันธ</span>
                            <img class="w-[60px] my-1.5" src="/images/sunIcon.svg" />
                            <div id="temperature" class="PC_H2-R">27 °C</div>
                            <div class="flex items-center gap-2">
                                <RainIcon />
                                <span>2%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue'

const selectedTab = ref('')

</script>
<style scoped>
.background {
    background: url("/images/background-img.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 70vh;
    margin-bottom: -40px;
    /* margin-right: -40px;
    margin-left: -40px; */
}

.image-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70vh;
    background: url("/images/background-img.jpg");
    /* center / cover no-repeat; */
    z-index: -1;
}

.content-container {
    position: relative;
    z-index: 1;
    padding: 20px;
    /* ปรับ padding ตามต้องการ */
}
</style>
